module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"reset_your_password":"Reset your password","reset_your_password_desc":"Enter a new password for your Yezza account","change_password":"Change password"},"id":{"reset_your_password":"Atur kata sandi","reset_your_password_desc":"Masukkan kata sandi baru untuk akun Yezza kamu","change_password":"Ubah kata sandi"}}')
  delete Component.options._Ctor
}
